/* eslint-disable no-console */
import React, { useRef, useState, useEffect, useContext } from 'react';
import { Box, Title, Button, Group, Grid, Center, Image, Space, Text, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';
import OTPInput from 'otp-input-react';
import { showNotification } from '@mantine/notifications';
import { useNavigate, useLocation } from 'react-router-dom';
import Keyboard from 'react-simple-keyboard';
import { CircleX, ArrowBackUp } from 'tabler-icons-react';
import BasicLayout from '../../components/BasicLayout';
import 'react-simple-keyboard/build/css/index.css';
import logo from '../../image/mouqfi.png';
import { sendRequest } from '../../services/services';
import AppContext from '../../components/Context/index';

dayjs.extend(duration);

const OTPVerify = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [seconds, setSeconds] = useState(0);
  const runOnce = useRef(true);
  const [layout, setLayout] = useState('default');
  const keyboard = useRef();
  const [inputData, setInputData] = useState('');
  const [profileData, setProfileData] = useState({});
  const [shiftButtonText, setShiftButtonText] = useState('Arabic');
  const searchParams = new URLSearchParams(search);
  const mobileNumber = searchParams.get('mobile');
  const countryCode = searchParams.get('countryCode');

  const appContextState = useContext(AppContext);
  const { handleUserLogin } = appContextState;

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      country_code_id: 194,
    },
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((value) => {
        if (value > 0) {
          return value - 1;
        }
        return value;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const generateOtp = () => {
    const body = { mobile: mobileNumber, country_code_id: countryCode };
    sendRequest(`cashier/generate-otp`, 'post', body)
      .then(({ data, code }) => {
        setSeconds(60);
        if (code === 20) {
          handleUserLogin(data);
          showNotification({
            title: <Text weight={500}>Success full send OTP</Text>,
          });
        } else if (code === 40) {
          showNotification({
            title: <Text weight={500}>User not registered!</Text>,
            icon: <CircleX size={16} />,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          navigate('/');
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
  };

  const fetchProfile = () => {
    sendRequest(`cashier/profile`, 'get').then((res) => {
      setProfileData(res?.data || []);
    });
  };

  const status = `?is_online=${!profileData?.is_online}`;
  const shiftUpdate = () => {
    sendRequest(`/cashier/change-status${status}`, 'post')
      .then(({ msg }) => {
        if (msg === 'Profile online status updated successfully!') {
          console.log('err', msg);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          // eslint-disable-next-line no-console
          console.log('err', err?.response?.data?.code);
        }
      });
  };

  const verifyOTP = () => {
    const body = {
      mobile: mobileNumber,
      country_code_id: countryCode,
      otp: inputData,
    };
    sendRequest(`cashier/signin`, 'post', body)
      .then(({ data, code }) => {
        if (code === 20) {
          handleUserLogin(data);

          if (!profileData?.online_from === null) {
            navigate('/home');
          }
          window.location.reload();
        } else if (code === 40) {
          showNotification({
            title: <Text weight={500}>Invalid OTP!</Text>,
            icon: <CircleX size={16} />,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
  };

  const onChangeInputNumber = (event) => {
    const data = event.target.value;
    setInputData(data);
    keyboard.current.setInputData(data);
  };

  const onChangeNumber = (inputValue) => {
    setInputData(inputValue);
  };

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (shiftButtonText === 'Arabic') {
      setShiftButtonText('English');
    } else if (shiftButtonText === 'English') {
      setShiftButtonText('Arabic');
    }
  };

  const onKeyPress = (button) => {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
  };

  useEffect(() => {
    if (runOnce.current) {
      runOnce.current = false;
      generateOtp();
      fetchProfile();
      shiftUpdate();
      console.log('OTP - Test');
    }
  });
  return (
    <BasicLayout>
      <Box>
        <Grid>
          <Grid.Col span={6} offset={3}>
            <Box
              sx={(theme) => ({
                backgroundColor:
                  theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
                padding: theme.spacing.xl,
                borderRadius: theme.radius.md,
              })}
            >
              <Button onClick={() => navigate('/')}>
                <ArrowBackUp size={30} />
              </Button>
              <Center>
                <Image radius="md" src={logo} alt="Random unsplash image" width="120px" />
              </Center>

              <Center py="sm">
                <Title order={3}>Verify OTP</Title>
              </Center>

              <form onSubmit={form.onSubmit((values) => console.log(values))}>
                <div style={{ marginTop: '10px' }}>
                  <Center>
                    <Stack>
                      <OTPInput
                        OTPLength={4}
                        inputStyles={{
                          width: '60px',
                          height: '40px',
                          fontSize: '1.5rem',
                        }}
                        value={inputData}
                        onChange={onChangeInputNumber}
                      />
                      {seconds > 0 ? (
                        <Text size="sm">
                          Resend code in {dayjs.duration(seconds * 1000).format('mm:ss')}
                        </Text>
                      ) : (
                        <Button
                          variant="subtle"
                          disabled={seconds > 0}
                          compact
                          onClick={() => {
                            generateOtp();
                          }}
                        >
                          Resend OTP
                        </Button>
                      )}
                    </Stack>
                  </Center>
                </div>
                <Space h="xl" />
                <Space h="xl" />
                <Center py="xl">
                  <Group>
                    <Button
                      type="submit"
                      style={{ width: '100%' }}
                      onClick={verifyOTP}
                      disabled={seconds <= 0}
                    >
                      Submit OTP
                    </Button>
                  </Group>
                </Center>
              </form>
            </Box>

            <Space h="xl" />

            <Space h="xl" />

            <Keyboard
              keyboardRef={(r) => {
                keyboard.current = r;
              }}
              onChange={onChangeNumber}
              onKeyPress={onKeyPress}
              layoutName={layout}
              maxLength={4}
              theme="hg-theme-default hg-layout-default myTheme enable-button"
              layout={{
                default: ['1 2 3 4 5 6 7 8 9 0 {bksp}'],
                shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
              }}
              display={{
                '{bksp}': '⌫',
                '{enter}': 'Enter',
              }}
            />
          </Grid.Col>
        </Grid>
      </Box>
    </BasicLayout>
  );
};

export default OTPVerify;
